/* Hero Spotlight Toggle (B案) — JOEKR用JS。元はSommers（hero-spotlight-toggle）。 */
(() => {
  const hero = document.querySelector('.jhero--spotlight');
  if (!hero) return;

  const toggleImg = hero.querySelector('.jhero__toggle-btn, .jhero__toggle-img');
  let isOn = false;
  let isLoading = true;

  // Loader: 800ms黒ホールド → 1s フェード
  window.setTimeout(() => {
    hero.classList.remove('jhero--loading');
    window.setTimeout(() => { isLoading = false; }, 1000);
  }, 800);

  if (toggleImg) {
    toggleImg.addEventListener('click', () => {
      if (isLoading) return;
      isOn = !isOn;
      hero.classList.toggle('is-on', isOn);
    });
  }

  // Spotlight reveal — radial-gradient mask
  const REVEAL_RADIUS = 220;
  let targetX = 0, targetY = 0;
  let currentX = 0, currentY = 0;
  let targetSize = 0, currentSize = 0;
  let initialized = false;

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    targetX = e.clientX - rect.left;
    targetY = e.clientY - rect.top;
    if (!initialized) {
      currentX = targetX; currentY = targetY;
      initialized = true;
    }
  });
  hero.addEventListener('mouseenter', () => { targetSize = REVEAL_RADIUS; });
  hero.addEventListener('mouseleave', () => { targetSize = 0; });

  function tick() {
    currentX += (targetX - currentX) * 0.18;
    currentY += (targetY - currentY) * 0.18;
    currentSize += (targetSize - currentSize) * 0.12;
    hero.style.setProperty('--mouse-x', currentX + 'px');
    hero.style.setProperty('--mouse-y', currentY + 'px');
    hero.style.setProperty('--reveal-size', currentSize + 'px');
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
